import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LanguageContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const { lang } = useLang();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      window.location.hash = "";
      nav("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    const target = window.location.pathname === "/" ? "/dashboard" : (window.location.pathname || "/dashboard");

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        if (r.data?.session_token) {
          localStorage.setItem("jnic_session_token", r.data.session_token);
        }
        setUser(r.data.user);
        window.location.hash = "";
        nav(target, { replace: true, state: { user: r.data.user } });
      } catch (e) {
        window.location.hash = "";
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 rounded-full border-2 border-[#D71920] border-t-transparent animate-spin mx-auto mb-4" />
        <p className="text-[#06162A]/60 text-sm tracking-wide font-medium">
          {lang === "fr" ? "Connexion en cours…" : "Signing in…"}
        </p>
      </div>
    </div>
  );
}
